import { SivSearch } from './esiv.model';
import { NoValue } from '@tribeauto/ngx-mobilite-material';

export const mapToSivSearch = (registrationNumberFromContract: string | NoValue): SivSearch => {
  const sivSearch: SivSearch = {
    sivImmats: []
  };
  if (registrationNumberFromContract) {
    sivSearch.sivImmats!.push(registrationNumberFromContract.toUpperCase());
  }
  return sivSearch;
};
